import { Grid, Typography } from "@mui/material";
import { Profile } from "@readyfit-common/models";
import { formatDate } from "../AthleteDetails";
import useStyles from "./TrainingCard.styles";

const TrainingCard = ({ athlete }: { athlete: Profile | null }) => {
  const classes = useStyles();
  const userInfo = athlete?.userInfo;

  return (
    athlete && (
      <Grid container className={classes.profileInformationContainer} gap={3}>
        <Grid item xs={12}>
          <Typography variant="h5">Training Profile</Typography>
        </Grid>

        <Grid
          item
          container
          marginTop={2}
          xs={12}
          className={classes.profileInformationColumnContainer}
        >
          <Grid container className={classes.profileInformationRow}>
            <Typography variant="caption" color={"#666666"}>
              Training for
            </Typography>

            <Typography variant="caption">
              {userInfo?.trainingFor || "-"}
            </Typography>
          </Grid>

          <Grid container className={classes.profileInformationRow}>
            <Typography variant="caption" color={"#666666"}>
              Training deadline
            </Typography>

            <Typography variant="caption">
              {userInfo?.trainingDeadline
                ? formatDate(userInfo?.trainingDeadline)
                : "-"}
            </Typography>
          </Grid>

          <Grid container className={classes.profileInformationRow}>
            <Typography variant="caption" color={"#666666"}>
              Done test before
            </Typography>

            <Typography variant="caption">
              {userInfo?.doneTestBefore || "-"}
            </Typography>
          </Grid>

          <Grid
            container
            className={classes.profileInformationRow}
            style={{ borderBottom: "0px" }}
          >
            <Typography variant="caption" color={"#666666"}>
              Current body weight
            </Typography>

            <Typography variant="caption">
              {userInfo?.currentBodyWeight}
            </Typography>
          </Grid>
        </Grid>

        <Grid
          item
          container
          marginTop={2}
          xs={12}
          className={classes.profileInformationColumnContainer}
        >
          <Grid container className={classes.profileInformationRow}>
            <Typography variant="caption" color={"#666666"}>
              Preferred military branch
            </Typography>

            <Typography variant="caption">
              {userInfo?.trainingMilitaryBranch || "-"}
            </Typography>
          </Grid>

          <Grid container className={classes.profileInformationRow}>
            <Typography variant="caption" color={"#666666"}>
              Important goal
            </Typography>

            <Typography variant="caption">
              {userInfo?.importantGoal || "-"}
            </Typography>
          </Grid>

          <Grid container className={classes.profileInformationRow}>
            <Typography variant="caption" color={"#666666"}>
              Fitness level
            </Typography>

            <Typography variant="caption">
              {userInfo?.fitnessLevel || "-"}
            </Typography>
          </Grid>

          <Grid
            container
            className={classes.profileInformationRow}
            style={{ borderBottom: "0px" }}
          >
            <Typography variant="caption" color={"#666666"}>
              Best 3 mile run
            </Typography>

            <Typography variant="caption">
              {userInfo?.best3mRun || "-"}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    )
  );
};

export default TrainingCard;
